import { api } from '@marketplace-web/core-api/core-api-client-data'
import { UserResp } from 'types/api/response/user-resp'

type GetUserByIdArgs = {
  id: number
  localize?: boolean
}

export const getUserById = ({ id, localize = false }: GetUserByIdArgs) =>
  api.get<UserResp>(`/users/${id}`, { params: { localize } })
